import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, buildFileUrl } from "../lib/api";
import { DhunLogo, AivigoFooter } from "../components/DhunLogo";
import { Smartphone, Headphones, Shield, Crown, ArrowRight } from "lucide-react";

export default function Landing() {
  const [pubs, setPubs] = useState([]);
  useEffect(() => {
    api.get("/pubs").then(({ data }) => setPubs(data)).catch(() => {});
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#0B0E14] px-6 py-10 text-white" data-testid="landing-page">
      <div className="pointer-events-none absolute -left-40 top-10 h-96 w-96 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(139,92,246,0.25) 0%, transparent 70%)" }} />
      <div className="pointer-events-none absolute -right-40 bottom-10 h-96 w-96 rounded-full"
        style={{ background: "radial-gradient(circle, rgba(236,72,153,0.25) 0%, transparent 70%)" }} />
      <div className="relative mx-auto max-w-5xl">
        <div className="flex items-center gap-3">
          <DhunLogo size={56} />
          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-violet-300">Nightlife music engagement</p>
            <h1 className="text-4xl font-black tracking-tight sm:text-5xl" style={{ fontFamily: "'Outfit', sans-serif" }}>Aivigo</h1>
          </div>
        </div>
        <p className="mt-4 max-w-2xl text-base text-slate-300">Request. Vote. Celebrate.</p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <div className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#131822] p-6" data-testid="landing-customer">
            <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-gradient-to-br from-violet-500 to-pink-500 opacity-20 blur-2xl" />
            <Smartphone className="h-7 w-7" />
            <h3 className="mt-4 text-xl font-extrabold">Customer</h3>
            <p className="mt-1 text-sm text-slate-400">Pick your pub — the QR at your table opens this.</p>
            <div className="mt-4 space-y-2">
              {pubs.map((p) => (
                <Link key={p.id} to={`/pub/${p.slug}`} data-testid={`landing-pub-${p.slug}`}
                  className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3 transition hover:border-violet-400/60">
                  {p.logo_url ? <img src={buildFileUrl(p.logo_url)} alt="" className="h-9 w-9 rounded-lg object-cover" /> : <DhunLogo size={36} />}
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold">{p.name}</p>
                    <p className="truncate text-xs text-slate-500">{p.tagline}</p>
                  </div>
                  <ArrowRight className="h-4 w-4 text-violet-300" />
                </Link>
              ))}
              {pubs.length === 0 && <p className="rounded-xl border border-dashed border-white/10 py-4 text-center text-xs text-slate-500">No pubs yet</p>}
            </div>
          </div>

          {[
            { to: "/dj", icon: Headphones, title: "DJ", desc: "Queue, shout-out approvals, vibe", testid: "landing-dj" },
            { to: "/admin", icon: Shield, title: "Pub admin", desc: "Revenue and alerts for your pub", testid: "landing-admin" },
            { to: "/owner", icon: Crown, title: "Owner", desc: "All pubs, revenue, alerts, settings", testid: "landing-owner" },
          ].map((t) => (
            <Link key={t.title} to={t.to} data-testid={t.testid}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-[#131822] p-6 transition hover:-translate-y-0.5 hover:border-white/30">
              <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-gradient-to-br from-cyan-500 to-violet-500 opacity-20 blur-2xl" />
              <t.icon className="h-7 w-7" />
              <h3 className="mt-4 text-xl font-extrabold">{t.title}</h3>
              <p className="mt-1 text-sm text-slate-400">{t.desc}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-violet-300">
                Sign in <ArrowRight className="h-3 w-3 transition group-hover:translate-x-1" />
              </div>
            </Link>
          ))}
        </div>
        <AivigoFooter className="mt-12" />
      </div>
    </div>
  );
}
